import gql from 'graphql-tag';

export const VIEW_POSITIONING_CONFIGURATION_BY_REGISTRY = gql`
    query viewPositioningConfigurationByRegistry($projectId: Int64!, $registryId: Int64!) {
        positioningConfiguration(projectId: $projectId, registryId: $registryId) { 
            project_id
            registry_id
            recent_position_duration
            lost_position_delay
            positions_always_active
        }
    }
`;

export const UPDATE_POSITIONING_CONFIGURATION = gql`
    mutation UpdateConfiguration($project_id: Int64!, $registry_id: Int64!, $input: PositioningConfigurationInput!) {
        updatePositioningConfiguration(projectId: $project_id, registryId: $registry_id, input: $input) {
            recent_position_duration
            positions_always_active
            lost_position_delay
        }
    }
`;
